import React from 'react'

import MenuTooltip from './MenuTooltip'

export const renderMenuTooltip = (options, toggleTooltip) => <MenuTooltip options={options} toggleTooltip={toggleTooltip} />
